import React, { Component, useEffect } from "react";

import useStore from "../store";

import Progress from "./components/Progress";
import Status from "./components/Status";
import WelcomeMessage from "./components/WelcomeMessage";
import Form from "./components/Form";

const New = (props) => {
  const { firstName, team, questions } = props;

  const { step, setQuestions } = useStore(state => state.onboarding);

  useEffect(() => {
    setQuestions(questions);
  }, [questions]);

  const renderStepView = (step) => {
    if (step == 0) {
      return <WelcomeMessage firstName={firstName} />;
    } else if (step >= 1 && step <= 15) {
      return <Form team={team} />;
    }
  }

  return (
    <div className="onboarding">
      <div className="onboarding-container">
        <div className="sidebar">
          <Progress currentStep={step} team={team} />
          <Status currentStep={step} />
        </div>
        <div className="content">
          {renderStepView(step)}
        </div>
      </div>
    </div>
  );
}

// NOTE: needed now to current version of ReactOnRails to work with Zustand
export default class NewComponent extends Component {
  render() {
    return <New {...this.props} />;
  }
}